<template>
  <div class="main-box">
    <a @click="showModal">设置</a>
    <a-modal
      title='设置'
      okText="保存"
      :visible='modalVisible'
      :confirmLoading='submitLoading'
      width='820px'
      @ok="submitEvent"
      @cancel="cancelEvent"
    >
      <a-form-model
        :label-col="{ span: 5}"
        :wrapper-col="{ span: 6}"
        :model="ruleForm"
        :rules="tabRule"
        ref="ruleForm"
      >
        <!--        <a-form-model-item-->
        <!--          label="加价设置"-->
        <!--          required-->
        <!--          :label-col="{ span: 4}"-->
        <!--          :wrapper-col="{ span: 16}"-->
        <!--        >-->
        <!--          <span style="color: red">说明：修改加价比例或汇率，保存后，需手动全量更新产品</span>-->
        <!--        </a-form-model-item>-->
        <div style="padding-left: 10px">
          <a-form-model-item label="同行价加价比例" prop="channelPeerRatio">
            <a-input
              placeholder="请输入"
              v-model.number="ruleForm.channelPeerRatio"
              :maxLength="4"
              addon-after="%"
            />
          </a-form-model-item>
          <a-form-model-item label="销售价加价比例" prop="channelSaleRatio">
            <a-input
              placeholder="请输入"
              v-model.number="ruleForm.channelSaleRatio"
              :maxLength="4"
              addon-after="%"
            />
          </a-form-model-item>
          <a-form-model-item label="市场价加价比例" prop="channelMarkRatio">
            <a-input
              placeholder="请输入"
              v-model.number="ruleForm.channelMarkRatio"
              :maxLength="4"
              addon-after="%"
            />
          </a-form-model-item>
          <a-form-model-item label="佣金" prop="channelCommission">
            <a-input
              class="content-box"
              placeholder="请输入"
              v-model.number="ruleForm.channelCommission"
              :maxLength="3"
              addon-after="%"
            />
          </a-form-model-item>
        </div>
        <div style="padding: 0 50px;color: #aaaaaa">
          <p style="margin: 0">说明：</p>
          <p style="margin: 0">1、同行价、销售价、市场价 比例值 输入范围 最小为0，最大为 1000</p>
          <p style="margin: 0">2、金额（销售、同行、市场） = （畅联金额 * 汇率）+ (畅联金额 * 汇率 * 加价比例）</p>
          <p style="margin: 0">3、佣金 比例值输入范围 最小为 0 ， 最大为 100; 计算后小数位最多保留2位</p>
          <p style="margin: 0">3、商城端显示价格时，显示整数，小数位 按四舍五入</p>
          <!--          <p style="margin-bottom: 10px;text-indent: 3em;">2、 前端商品显示价格时，显示整数，小数位 按四舍五入</p>-->
        </div>
        <a-form-model-item
          label="汇率设置"
          :label-col="{ span: 4}"
          :wrapper-col="{ span: 6}"
          prop="channelExchangeRate"
        >
          <a-input
            placeholder="请输入"
            v-model="ruleForm.channelExchangeRate"
            :maxLength="8"
          />
        </a-form-model-item>
        <p style="padding-left: 110px;color: #aaaaaa">说明：仅支持港币兑换人民币汇率 ，支持小数点后四位</p>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
export default {
  name: 'changLianConfig',
  data() {
    return {
      modalVisible: false,
      ruleForm: {},
      tabRule: {
        channelPeerRatio: [
          { required: true, message: '请输入同行价加价比例', trigger: ['blur', 'change'] },
          // { pattern: /^(?:[1-9]|[1-9][0-9]|[1-4][0-9]{2}|500)$/, message: "只能输入小于等于500的正整数",trigger: ['blur', 'change']},
          { type: 'number', min: 0, max: 1000, message: '只能输入0-1000之间的整数', trigger: ['blur', 'change'] }
        ],
        channelSaleRatio: [
          { required: true, message: '请输入销售价加价比例', trigger: ['blur', 'change'] },
          // { pattern: /^(?:[1-9]|[1-9][0-9]|[1-4][0-9]{2}|500)$/, message: "只能输入小于等于500的正整数",trigger: ['blur', 'change']},
          { type: 'number', min: 0, max: 1000, message: '只能输入0-1000之间的整数', trigger: ['blur', 'change'] },
          { validator: this.checkAdvicePrice, trigger: ['blur', 'change'] }
        ],
        channelMarkRatio: [
          { required: true, message: '请输入市场价加价比例', trigger: ['blur', 'change'] },
          // { pattern: /^(?:[1-9]|[1-9][0-9]|[1-4][0-9]{2}|500)$/, message: "只能输入小于等于500的正整数",trigger: ['blur', 'change']},
          { type: 'number', min: 0, max: 1000, message: '只能输入0-1000之间的整数', trigger: ['blur', 'change'] },
          { validator: this.checkMarketPrice, trigger: ['blur', 'change'] }
        ],
        channelCommission: [
          { required: true, message: '请输入佣金', trigger: ['blur', 'change'] },
          { type: 'number', min: 0, max: 100, message: '只能输入0-100之间的整数', trigger: ['blur', 'change'] }
        ],
        channelExchangeRate: [
          { required: true, message: '请输入汇率设置', trigger: ['blur', 'change'] },
          { validator: this.checkExchangeRate, trigger: ['blur', 'change'] }
        ]
      },
      submitLoading: false
    }
  },
  methods: {
    getDetailInfo() {
      return new Promise(resolve => {
        this.ruleForm = {}
        this.getHttpServices().getServerApiService().post('/dsn/account/query/config', {
          merchantId: this.$store.getters.userInfo.merchantId,
          platformId: this.getPlatformConfig().platformId
        }).then(res => {
          if (res) {
            this.ruleForm = {
              ...res,
              channelPeerRatio: res.channelPeerRatio - 100,
              channelSaleRatio: res.channelSaleRatio - 100,
              channelMarkRatio: res.channelMarkRatio - 100
            }
            resolve()
          } else {
            this.$message.error('请先完善API配置信息')
          }
        }).catch(reason => this.showNetWorkErrorMessage(reason))
      })
    },
    checkAdvicePrice(rule, value, callback) {
      setTimeout(() => {
        if (Number(value) < Number(this.ruleForm.channelPeerRatio)) {
          callback(new Error('销售价大于或等于同行价'))
        } else {
          callback()
        }
      }, 200)
    },
    checkMarketPrice(rule, value, callback) {
      setTimeout(() => {
        if (Number(value) < Number(this.ruleForm.channelSaleRatio)) {
          callback(new Error('市场价大于或等于销售价'))
        } else {
          callback()
        }
      }, 200)
    },
    checkExchangeRate(rule, value, callback) {
      if (value || value === 0) {
        if (!/^([1-9]\d{0,2}|0)([.]?|(\.\d{1,4})?)$/.test(value) || String(value).endsWith('.')
          || Number(value) <= 0 || Number(value) > 100
        ) {
          callback(new Error('仅支持小于等于100且小数点后四位正数'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    async showModal() {
      await this.getDetailInfo()
      this.modalVisible = true
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate()
      })
    },
    cancelEvent() {
      this.modalVisible = false
    },
    submitEvent() { //提交
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.updateRequest()
        } else {
          this.$message.error('请完善必要的信息')
        }
      })
    },
    updateRequest() {
      if (!this.submitLoading) {
        this.submitLoading = true
        this.getHttpServices().getServerApiService().post('/dsn/account/edit/ratio', {
          ...this.ruleForm,
          channelPeerRatio: Number(this.ruleForm.channelPeerRatio) + 100,
          channelSaleRatio: Number(this.ruleForm.channelSaleRatio) + 100,
          channelMarkRatio: Number(this.ruleForm.channelMarkRatio) + 100,
          channelExchangeRate: Number(this.ruleForm.channelExchangeRate),
          merchantId: this.$store.getters.userInfo.merchantId,
          platformId: this.getPlatformConfig().platformId
        }).then(res => {
          this.$message.success('保存成功')
          this.cancelEvent()
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.submitLoading = false)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.main-box {
  display: inline-block;
}

::v-deep .ant-form-item {
  margin-bottom: 10px;
}

.content-box {
  position: relative;

  &:after {
    content: '× (销售价 - 同行价)';
    font-size: 14px;
    color: #AAAAAA;
    position: absolute;
    right: -125px;
    top: -4px;
  }
}
</style>
